// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.ultimate",
    name: "Ultimate",
    homepage: "https://ultimate.app/",
    image_id: "1ed9823d-64dd-4ab6-2f3f-22c8ff228f00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/id1629053410",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "ultimate://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map